import { FC, memo } from 'react'
import { Box, BoxProps } from '@chakra-ui/react'

const CustomDivider: FC<BoxProps> = () => {
  return (
    <Box id="divider" className="accessible divider" borderTopWidth="1px" borderColor="borderColor" rounded="full" />
  )
}

export default memo(CustomDivider)
